import { api } from "#web/services/api";
import { i18nLike } from "#web/services/i18nLike";
import { Modal, Text, TextField } from "@shopify/polaris";
import { useCallback, useState } from "react";

const en = {
  apply: "Apply",
  cancel: "Cancel",
  enterYourCode: "Enter your code",
  invalidPromoCode: "Invalid promo code: {{promoCode}}",
  title: "Enter your code",
};

interface CustomPlanModalProps {
  onClose: () => void;
  open: boolean;
  subscribeTo: (id: string) => Promise<void>;
}

export const CustomPlanModal = ({ onClose, open, subscribeTo }: CustomPlanModalProps) => {
  const t = i18nLike(en);

  const [promoCode, setPromoCode] = useState<string>("");
  const handlePromoCodeChange = useCallback((newValue: string) => {
    setPromoCode(newValue);
  }, []);

  const [error, setError] = useState<string>("");

  const subscribeToCustom = useCallback(async (promoCode: string) => {
    setError("");
    const customBillingPlan = await api.subscriptionPlan.maybeFindFirst({
      filter: { customPlan: { equals: promoCode } },
      select: {
        id: true,
      },
    });
    if (customBillingPlan) {
      await subscribeTo(customBillingPlan.id);
    } else {
      setError(t("invalidPromoCode", { promoCode }));
    }
  }, []);

  return (
    <Modal
      onClose={onClose}
      open={open}
      primaryAction={{
        content: t("apply"),
        onAction: () => {
          void subscribeToCustom(promoCode);
        },
      }}
      secondaryActions={[
        {
          content: t("cancel"),
          onAction: onClose,
        },
      ]}
      size="small"
      title={t("title")}
    >
      <Modal.Section>
        <TextField autoComplete="off" label="" onChange={handlePromoCodeChange} value={promoCode} />
        {error.length > 0 && (
          <Text as="p" tone="critical">
            {error}
          </Text>
        )}
      </Modal.Section>
    </Modal>
  );
};
